import type { Editor } from '@tiptap/core'

/** The schemes without an authority that a link may use; the system's mail, phone or messaging app opens them */
export const APP_LINK_SCHEME = /^(mailto|tel|sms):/i

/** A scheme with an authority (https://, ftp://) or one of the schemes that go without (mailto:, tel:, sms:) */
const HAS_SCHEME = /^([a-z][a-z0-9+.-]*:\/\/|(mailto|tel|sms):)/i

/**
 * The href for a link typed into the link input: a plain domain gets http://, as it always has. A URL that already
 * has a scheme stays as typed. Relative hrefs (#, /path) are not kept: the editor drops them when the page reloads.
 */
export function normalizeLinkHref(link: string): string {
  const href = link.trim()
  if (HAS_SCHEME.test(href)) return href
  return 'http://' + href
}

/**
 * The href of the link at the editor's selection, or '' outside a link. Unlike a search of the selected range, it also
 * finds the link for a caret at the edge of its text, where the formatting bubble shows too (isActive).
 */
export function selectedLinkHref(editor: Editor): string {
  return editor.getAttributes('link').href || ''
}
